import styled from 'styled-components';
import { position as positionStyles } from 'styled-system';

const StyledSidebarFooter = styled.footer.attrs(() => ({
	dataTestid: 'sidebar-footer'
	// Every <Button /> will now have type="button" as default
}))`
	width: 100%;
	bottom: 0;
	flex: 0 1 auto;
	${positionStyles}
`;

const SidebarFooter = ({ children, position = 'sticky', ...rest }) => (
	<StyledSidebarFooter data-testid="sidebar-footer" position={position} {...rest}>
		{children}
	</StyledSidebarFooter>
);

export default SidebarFooter;
